// messageAPI.js
import { API_CONFIG } from "../../utils/api-config";
import fetchWithAuth from "../../utils/apiAthurization";

/* ------------------------------------
   SEND MESSAGE
------------------------------------ */
export const SendMessage = async data => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/messaging/messages/send`,
      "POST",
      data
    );
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Message sending failed",
      statusCode: error.response?.status || 500
    };
  }
};

/* ------------------------------------
   INBOX
------------------------------------ */
export const InboxMessages = async () => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/messaging/messages/inbox`
    );
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Inbox fetching failed",
      statusCode: error.response?.status || 500
    };
  }
};

/* ------------------------------------
   OUTBOX
------------------------------------ */
export const OutboxMessages = async () => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/messaging/messages/outbox`
    );
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Outbox fetching failed",
      statusCode: error.response?.status || 500
    };
  }
};

/* ------------------------------------
   GET MESSAGE BY ID
------------------------------------ */
export const GetMessageById = async id => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/messaging/messages/${id}`
    );
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Message not found",
      statusCode: error.response?.status || 500
    };
  }
};

/* ------------------------------------
   MARK MESSAGE AS READ
------------------------------------ */
export const MarkMessageAsRead = async id => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/messaging/messages/${id}/read`,
      "PUT"
    );
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Read update failed",
      statusCode: error.response?.status || 500
    };
  }
};

/* ------------------------------------
   DELETE MESSAGE (PER USER)
------------------------------------ */
export const DeleteMessage = async id => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/messaging/messages/${id}`,
      "DELETE"
    );
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Message delete failed",
      statusCode: error.response?.status || 500
    };
  }
};
